<script setup lang="ts">
  import type {
    ComboboxFieldItem,
    ComboboxFieldProps
  } from '@gat-ship/vue-components'
  import { computed } from 'vue'
  import type { TargetPromptAiModel } from '../model/types'
  import AiThinkingModelIcon from './AiThinkingModelIcon.vue'
  import { IconChevronDown, IconCheck } from '@gat-ship/icons'
  import { ComboboxField } from '@gat-ship/vue-components'

  export interface SelectThinkingModelProps extends Omit<
    ComboboxFieldProps,
    'items' | 'modelValue'
  > {
    baseInstructionAiModel?: string
  }

  const props = withDefaults(defineProps<SelectThinkingModelProps>(), {
    baseInstructionAiModel: undefined
  })

  const selectedThinkingModel = defineModel<TargetPromptAiModel | undefined>({
    required: true
  })

  const thinkingModels = computed(
    (): ComboboxFieldItem<TargetPromptAiModel>[] => {
      const models: ComboboxFieldItem<TargetPromptAiModel>[] = []
      models.push({
        title: props.baseInstructionAiModel
          ? `Base Instruction (${props.baseInstructionAiModel})`
          : 'Default',
        value: 'default',
        searchValue: 'default',
        metaData: 'default'
      })
      models.push(
        {
          title: 'Light',
          value: 'light',
          searchValue: 'light',
          metaData: 'light'
        },
        {
          title: 'Standard',
          value: 'standard',
          searchValue: 'standard',
          metaData: 'standard'
        },
        {
          title: 'Extended',
          value: 'extended',
          searchValue: 'extended',
          metaData: 'extended'
        }
      )
      return models
    }
  )
</script>
<template>
  <ComboboxField
    v-bind="props"
    v-model="selectedThinkingModel"
    :items="thinkingModels"
    :popover-props="{ class: 'min-w-[200px]' }"
    placeholder="Thinking Model"
  >
    <template #trigger="{ selectedTitle }">
      <div
        class="flex h-[36px] w-fit cursor-pointer gap-1.5 rounded-lg pl-2 pr-2.5 text-[#0285ff] hover:bg-[#e5f3ff]"
      >
        <div class="shrink-0 self-center pb-1.5">
          <AiThinkingModelIcon
            class="size-5"
            :ai-model="selectedThinkingModel ?? 'default'"
          />
        </div>
        <div class="flex grow self-center truncate text-sm">
          {{ selectedTitle }}
        </div>
        <div class="shrink-0 self-center">
          <IconChevronDown class="size-4" />
        </div>
      </div>
    </template>
    <template #prepend-content-item>
      <div class="flex items-center gap-1 px-2 py-2 text-xs text-neutral-700">
        <span>Thinking Model</span>
      </div>
    </template>
    <template #item="{ item, selected }">
      <div class="flex w-full items-center gap-2">
        <div class="shrink-0 items-center justify-center">
          <AiThinkingModelIcon :ai-model="item.metaData" class="size-5" />
        </div>
        <div class="w-full truncate">
          {{ item.title }}
        </div>
        <div v-if="selected" class="shrink-0 items-center justify-center">
          <IconCheck class="size-4" />
        </div>
      </div>
    </template>
  </ComboboxField>
</template>
